import {formatRecipientFullName} from './paymentRecipient';
import type {PersonalInfoStepValues} from './types';

type IdentificationName = {
	secondName?: string | null;
	firstName?: string | null;
	patronymic?: string | null;
};

const normalizeFullName = (fullName: string): string => {
	return fullName.trim().toLowerCase().replace(/\s+/g, ' ');
};

export const buildFullNameFromIdentificationInfo = (info: IdentificationName): string => {
	return [info.secondName, info.firstName, info.patronymic]
		.map((part) => (part ?? '').trim())
		.filter(Boolean)
		.join(' ');
};

export const hasIdentificationNameChanged = (
	before: PersonalInfoStepValues,
	after: IdentificationName,
): boolean => {
	const previousName = normalizeFullName(formatRecipientFullName(before));
	const nextName = normalizeFullName(buildFullNameFromIdentificationInfo(after));

	return previousName.length > 0 && nextName.length > 0 && previousName !== nextName;
};
